import { FC } from 'react'
import Button from '@components/button'
import { Helper } from '@utils'
interface StatusProps {
  status: string
}
const Status: FC<StatusProps> = ({ status }) => {
  const item = Helper.getStatusColor(status)
  return (
    <Button
      disabled
      bg={item?.bg}
      tc={item?.text}
      outline={item?.outline}
      styleButton="
          font-size:12px;
          padding:0px 10px;
      "
      height={30}
    >
      {status}
    </Button>
  )
}

export default Status
